import React from 'react';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';

const StartInvesting = () => {
  usePageTitle('Start Investing');
  return (
    <div className="page-content">
      <h1 className="page-title">4. Start Investing</h1>
      <div className="lorem-content">
        <p>
        You can invest in a lot of things:
        </p>
        <ul>
        <li>The Stock Market</li>
        <li>Real Estate</li>
        <li>Cryptocurrency</li>
        <li>etc. etc.</li>
        </ul>
        <p>
        Each of these options has its pros and cons and its fans and detractors. Here, we will stay focussed on the stock market.
        </p>
        <p>
        Like everything else in life, the stock market has its ups and downs. Especially on a day to day basis, the market goes up and down. As it does week over week and month over month and year over year. But, over the real long term though - decades - it has only gone up. For the entire history of the stock market to date - it has gone up. Here's some data: since 1957, when the S&P 500 was constituted, over any sliding 10 year period, the market has gone up almost 90% of the time. Over ANY sliding 13 year period it has gone UP 100% OF THE TIME.
        </p>
        <p>
        In other words no matter what your first year of investment was: 1957 (when Dwight Eisenhower was president), 2010 (when Barack Obama was president) or anytime in between, the stock market has always gone up i.e. NEVER gone down - IF you waited just 13 years. That's about as close as you'll get to a sure thing with something as fickle and volatile in the short term as the stock market. The real secret of the stock market isn't a secret at all. It is just one thing: time.
        </p>
        <p>
        Since no one lives forever, make the most of your time. The best time to start investing (for the long term) is today. For the market as a whole, Past is Prologue.</p>
        <p>
        There are literally thousands of public companies. So which one should you pick? Perhaps a bit counterintuitively, I recommend AGAINST <Link to="/avoid-picking-individual-stocks">picking individual stocks</Link>.
        </p>
      </div>
      <Link to="/steps-to-financial-freedom" className="back-link">
        Back to Steps
      </Link>
    </div>
  );
};

export default StartInvesting; 